import React from 'react'
import SectionWrapper from 'components/Wrapper/SectionWrapper'
import { Card, Col, Container, Row } from 'react-bootstrap'

const OurTeam = () => {

    return (
        <SectionWrapper>
            <Container>
                <Row>
                    <Col>
                        <h2 className='text-center mb-3'>
                            Our Team
                        </h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card>
                            <Card.Img src={`${process.env.PUBLIC_URL}/assets/img/logo.png`} />
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <Card.Img src={`${process.env.PUBLIC_URL}/assets/img/logo.png`} />
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <Card.Img src={`${process.env.PUBLIC_URL}/assets/img/logo.png`} />
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <Card.Img src={`${process.env.PUBLIC_URL}/assets/img/logo.png`} />
                        </Card>
                    </Col>
                </Row>
            </Container>
        </SectionWrapper>
    )
}

export default OurTeam